// extracted by mini-css-extract-plugin
export default {"root":"s6f3OO","opaque":"T3k20s"};